import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  // shared
  app_name: { en: "KINOS", tt: "KINOS" },
  app_tagline: { en: "Leading Innovation Technology", tt: "Liderasaun Tekno Inovasaun" },
  language: { en: "Language", tt: "Lia-tetun" },
  save: { en: "Save", tt: "Rai" },
  cancel: { en: "Cancel", tt: "Kansela" },
  edit: { en: "Edit", tt: "Edita" },
  delete: { en: "Delete", tt: "Hamoos" },
  view: { en: "View", tt: "Haree" },
  add: { en: "Add", tt: "Aumenta" },
  search: { en: "Search", tt: "Buka" },
  actions: { en: "Actions", tt: "Asaun" },
  status: { en: "Status", tt: "Estatus" },
  total: { en: "Total", tt: "Total" },
  subtotal: { en: "Subtotal", tt: "Subtotal" },
  tax: { en: "Tax", tt: "Taxa" },
  tax_rate: { en: "Tax rate (%)", tt: "Taxa (%)" },
  date: { en: "Date", tt: "Data" },
  notes: { en: "Notes", tt: "Nota" },
  confirm_delete: { en: "Are you sure?", tt: "Sertu duni?" },
  no_data: { en: "No records yet.", tt: "Seidauk iha rejistu." },
  loading: { en: "Loading…", tt: "Karega…" },

  // nav
  dashboard: { en: "Dashboard", tt: "Painel" },
  clients: { en: "Clients", tt: "Kliente sira" },
  inventory: { en: "Inventory", tt: "Inventáriu" },
  orders: { en: "Client Orders", tt: "Husu Kliente" },
  delivery_orders: { en: "Delivery Orders", tt: "Ordem Entrega" },

  // dashboard
  hero_title: { en: "Financial and Management System", tt: "Sistema Financeiru no Jestaun" },
  hero_sub: {
    en: "Track inventory, orders, and deliveries in one place.",
    tt: "Akompaña inventáriu, husu, no entrega iha fatin ida.",
  },
  total_clients: { en: "Clients", tt: "Kliente" },
  total_items: { en: "Inventory SKUs", tt: "Inventáriu SKU" },
  total_orders: { en: "Client Orders", tt: "Husu Kliente" },
  inventory_value: { en: "Inventory value", tt: "Valor inventáriu" },
  do_pending: { en: "Pending", tt: "Hein" },
  do_in_transit: { en: "In transit", tt: "Iha dalan" },
  do_delivered: { en: "Delivered", tt: "Entrega ona" },
  low_stock: { en: "Low stock items", tt: "Items stock kraik" },
  recent_dos: { en: "Recent delivery orders", tt: "Ordem entrega foun" },

  // clients
  client_name: { en: "Client name", tt: "Naran kliente" },
  contact_person: { en: "Contact person", tt: "Pesoa kontaktu" },
  email: { en: "Email", tt: "Email" },
  phone: { en: "Phone", tt: "Telefone" },
  address: { en: "Address", tt: "Endresu" },
  new_client: { en: "New client", tt: "Kliente foun" },
  edit_client: { en: "Edit client", tt: "Edita kliente" },

  // items
  item_name: { en: "Item name", tt: "Naran sasán" },
  specification: { en: "Specification", tt: "Espesifikasaun" },
  sku: { en: "SKU", tt: "SKU" },
  unit: { en: "Unit", tt: "Unidade" },
  stock_qty: { en: "Stock qty", tt: "Stock kuantidade" },
  qty: { en: "Qty", tt: "Kuantidade" },
  reorder_level: { en: "Reorder level", tt: "Nivel re-order" },
  price: { en: "Unit price", tt: "Presu unidade" },
  category: { en: "Category", tt: "Kategoria" },
  new_item: { en: "New item", tt: "Sasán foun" },
  edit_item: { en: "Edit item", tt: "Edita sasán" },

  // orders
  order_number: { en: "Order #", tt: "Numeru husu" },
  order_date: { en: "Order date", tt: "Data husu" },
  client: { en: "Client", tt: "Kliente" },
  new_order: { en: "New order", tt: "Husu foun" },
  add_line: { en: "Add line item", tt: "Aumenta liña" },
  select_item: { en: "Select an item…", tt: "Hili sasán…" },
  select_client: { en: "Select a client…", tt: "Hili kliente…" },
  line_total: { en: "Line total", tt: "Total liña" },
  convert_to_do: { en: "Convert to Delivery Order", tt: "Konverte ba Ordem Entrega" },
  order_status_draft: { en: "Draft", tt: "Razuñu" },
  order_status_confirmed: { en: "Confirmed", tt: "Konfirma" },
  order_status_converted: { en: "Converted", tt: "Konverte ona" },

  // delivery orders
  do_number: { en: "DO #", tt: "Numeru DO" },
  delivery_date: { en: "Delivery date", tt: "Data entrega" },
  delivery_address: { en: "Delivery address", tt: "Endresu entrega" },
  carrier: { en: "Carrier", tt: "Kareta" },
  download_pdf: { en: "Download PDF", tt: "Baixa PDF" },
  mark_in_transit: { en: "Mark in transit", tt: "Marka iha dalan" },
  mark_delivered: { en: "Mark delivered", tt: "Marka entrega ona" },
  status_pending: { en: "Pending", tt: "Hein" },
  status_in_transit: { en: "In transit", tt: "Iha dalan" },
  status_delivered: { en: "Delivered", tt: "Entrega ona" },
  status_cancelled: { en: "Cancelled", tt: "Kansela ona" },
  order_ref: { en: "Order ref", tt: "Referensia husu" },

  // inventory split
  general_inventory: { en: "General Inventory", tt: "Inventáriu Jeral" },
  general_inventory_hint: {
    en: "Items you own — stock you sell or deliver.",
    tt: "Sasán ne'ebé ó nia — stock ne'ebé ó faan ka entrega.",
  },
  client_assets: { en: "Client Assets", tt: "Asét Kliente nian" },
  client_assets_hint: {
    en: "Items delivered to clients, with warranty & support tracking.",
    tt: "Sasán ne'ebé entrega ba kliente, ho garantia no suporta.",
  },
  total_assets: { en: "Client assets", tt: "Asét kliente" },
  active_assets: { en: "Active assets", tt: "Asét aktivu" },
  expiring_soon: { en: "Expiring in 30 days", tt: "Ramata iha loron 30" },

  // asset fields
  asset_type: { en: "Type", tt: "Tipu" },
  brand: { en: "Brand", tt: "Marka" },
  model: { en: "Model", tt: "Modelu" },
  serial_number: { en: "Serial #", tt: "Numeru seri" },
  origin: { en: "Origin", tt: "Hosi" },
  location: { en: "Location", tt: "Fatin" },
  warranty: { en: "Warranty", tt: "Garantia" },
  support: { en: "Support", tt: "Suporta" },
  warranty_months: { en: "Warranty (months)", tt: "Garantia (fulan)" },
  support_months: { en: "Support (months)", tt: "Suporta (fulan)" },
  warranty_start: { en: "Warranty start", tt: "Garantia hahú" },
  warranty_end: { en: "Warranty end", tt: "Garantia ramata" },
  support_start: { en: "Support start", tt: "Suporta hahú" },
  support_end: { en: "Support end", tt: "Suporta ramata" },
  new_asset: { en: "New asset", tt: "Asét foun" },
  edit_asset: { en: "Edit asset", tt: "Edita asét" },
  asset_status: { en: "Asset status", tt: "Estatus asét" },
  status_active: { en: "Active", tt: "Aktivu" },
  status_expired: { en: "Expired", tt: "Ramata ona" },
  status_replaced: { en: "Replaced", tt: "Troka ona" },
  status_returned: { en: "Returned", tt: "Fila ona" },
  status_decommissioned: { en: "Decommissioned", tt: "Hasai ona" },
  open_client: { en: "Open client", tt: "Hare kliente" },
  back_to_clients: { en: "Back to clients", tt: "Fila ba kliente sira" },
  client_details: { en: "Client details", tt: "Detallu kliente" },
  none: { en: "—", tt: "—" },
  days_left: { en: "days left", tt: "loron sei iha" },
  link_to_item: { en: "Link to inventory item (optional)", tt: "Liga ba sasán inventáriu (opsional)" },

  // tender / PO
  tender_name: { en: "Tender name", tt: "Naran tender" },
  tender_number: { en: "Tender number", tt: "Numeru tender" },
  po_number: { en: "PO number", tt: "Numeru PO" },
  edit_do_info: { en: "Edit DO details", tt: "Edita detallu DO" },
  do_info_saved: { en: "Delivery order updated", tt: "Ordem entrega atualiza ona" },
  convert_with_info: { en: "Convert with details", tt: "Konverte ho detallu" },
  tender_po: { en: "Tender / PO", tt: "Tender / PO" },

  // serials per line
  serials: { en: "Serial numbers", tt: "Numeru seri sira" },
  serials_hint: {
    en: "One serial per unit. Saved on the DO and synced to client assets.",
    tt: "Numeru seri ida ba unidade ida. Rai iha DO no sinkroniza ho asét kliente.",
  },
  edit_serials: { en: "Edit serials", tt: "Edita numeru seri" },
  save_serials: { en: "Save serials", tt: "Rai numeru seri" },
  serials_saved: { en: "Serial numbers saved", tt: "Numeru seri rai ona" },
  unit_n: { en: "Unit", tt: "Unidade" },

  // DO summary (no pricing)
  summary: { en: "Summary", tt: "Sumáriu" },
  lines: { en: "Lines", tt: "Liña" },
  units: { en: "Units", tt: "Unidade sira" },
  pricing_disclaimer: {
    en: "Pricing is intentionally not shown on Delivery Orders. See the related Invoice for billing.",
    tt: "Presu la mostra iha Ordem Entrega. Haree Fatura ba pagamentu.",
  },

  // invoices
  invoices: { en: "Invoices", tt: "Fatura sira" },
  quotations: { en: "Quotations", tt: "Kotasaun sira" },
  users_roles: { en: "Users & Roles", tt: "Uzuáriu & Papél" },
  settings: { en: "Settings", tt: "Konfigurasaun" },
  reports: { en: "Reports", tt: "Relatóriu" },
  expenses: { en: "Expenses", tt: "Kustu" },
  loans: { en: "Financing", tt: "Financiamentu" },
  attendance: { en: "Client Attendance", tt: "Prezensa Kliente" },
  suppliers: { en: "Suppliers", tt: "Fornesedór" },
  rfqs: { en: "Requests for Quotation", tt: "Pedidu Kotasaun" },
  software_licences: { en: "Software Licences", tt: "Lisensa Software" },
  payment_claims: { en: "Payment Claims", tt: "Relatóriu Pagamentu" },
  project_funds: { en: "Project Funds", tt: "Fundu Projetu" },
  bills: { en: "Rent & Bills", tt: "Aluga & Konta" },
  payroll: { en: "Payroll", tt: "Saláriu" },
  leave: { en: "Leave", tt: "Lisensa Deskansu" },
  company_assets: { en: "Company Assets", tt: "Ativu Empreza" },
  purchase_orders: { en: "Purchase Orders", tt: "Ordem Kompra" },
  invoice: { en: "Invoice", tt: "Fatura" },
  invoice_number: { en: "Invoice #", tt: "Numeru fatura" },
  issue_date: { en: "Issue date", tt: "Data emisaun" },
  due_date: { en: "Due date", tt: "Data limite" },
  new_invoice: { en: "New invoice", tt: "Fatura foun" },
  create_invoice: { en: "Create invoice", tt: "Kria fatura" },
  payment_method: { en: "Payment method", tt: "Metodu pagamentu" },
  payment_date: { en: "Payment date", tt: "Data pagamentu" },
  terms: { en: "Terms", tt: "Termu" },
  currency: { en: "Currency", tt: "Moneda" },
  mark_sent: { en: "Mark as sent", tt: "Marka entrega ona" },
  mark_paid: { en: "Mark as paid", tt: "Marka selu ona" },
  status_draft: { en: "Draft", tt: "Razuñu" },
  status_sent: { en: "Sent", tt: "Haruka ona" },
  status_paid: { en: "Paid", tt: "Selu ona" },
  status_overdue: { en: "Overdue", tt: "Liu prazu" },
  source: { en: "Source", tt: "Fonte" },
  total_due: { en: "Total due", tt: "Total selu" },

  // serials bulk paste
  paste_serials: { en: "Paste serials", tt: "Kola numeru seri" },
  paste_serials_hint: {
    en: "Paste or scan one serial per line. They will fill Unit #1, #2, … in order.",
    tt: "Kola ka skén numeru seri ida iha liña ida. Sira sei prienxe Unidade #1, #2, …",
  },
  apply: { en: "Apply", tt: "Aplika" },
};

const I18nContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);
  const t = (key) => {
    const entry = DICT[key];
    if (!entry) return key;
    return entry[lang] || entry.en || key;
  };
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
